import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TransferStateService } from '@scullyio/ng-lib';

@Injectable({
  providedIn: 'root'
})
export class PricingResolver implements Resolve<any> {
  constructor(private http: HttpClient,
    private transferStateService:TransferStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const lang = route.url[0].path;
        
    const url = `../../../assets/${environment.projectName}/content/${lang}/price-page/pricing.json`;
    const metadataUrl = `../../../assets/${environment.projectName}/content/${lang}/price-page/meta-data.json`;
    
    return forkJoin({
      data: this.transferStateService.useScullyTransferState('maindata',this.http.get<any>(url).pipe(catchError(() => of(null)))),
      meta: this.transferStateService.useScullyTransferState('metadata',this.http.get<any>(metadataUrl).pipe(catchError(() => of(null))))
    }).pipe(
      map((result) => ({
        data: result.data,
        meta: result.meta
      })),
      catchError((error) => {
        console.error('Error fetching pricing or metadata:', error);
        return of(null);
      })
    );
  }
}
